module.exports = __webpack_public_path__ + "img/shipment-sync.1696889b.svg";